// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { carouselStyles } from "@guestsupply/Overrides/Components/ProductCompareCarousel";
import { color, xScreen } from "@guestsupply/XDL/Utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

carouselStyles.titleText = {
    variant: "h2",
    css: css`
        text-align: center;
        margin-bottom: 10px;
    `,
};

carouselStyles.mainContainer = {
    gap: 0,
    css: css`
        margin: 0 auto;
        ${xScreen("gte", "lg")} {
            max-width: 1312px;
        }
    `,
};

carouselStyles.carouselCellGridItem = {
    width: 8,
    css: css`
        &&&& {
            flex-basis: 100%;
            max-width: 100%;
            margin: 0 auto;
            .swiper-slide {
                // to make all slider same height
                height: auto;
                // To fix swiper render issue
                margin-top: 1px;
                margin-bottom: 1px;
                max-width: calc(25% - 20px);
                ${xScreen("lte", "md")} {
                    max-width: calc(33% - 15px);
                }
                ${xScreen("lte", "sm")} {
                    max-width: calc(50% - 20px);
                }
                ${xScreen("lte", "xs")} {
                    max-width: 100%;
                }
            }
        }
    `,
};

carouselStyles.attributeValueText = {
    ellipsis: true,
};

carouselStyles.attributeWrapper = {
    css: css`
        margin-top: 40px;
        width: 100%;
        max-width: 100%;
    `,
};

carouselStyles.attributeContainer = {
    css: css`
        width: 100%;
        max-width: 100%;
        background-color: ${color("common.white")};
    `,
};

carouselStyles.attributeLabel = {
    as: "p",
    size: 15,
    weight: "bold",
    color: "common.white",
    css: css`
        letter-spacing: 0;
        line-height: 20px;
        padding: 10px 10px 10px 15px;
        background: ${getColor("common.ui5")};
        min-height: 36px;
    `,
};

carouselStyles.attributeValue = {
    as: "p",
    size: 15,
    css: css`
        letter-spacing: 0;
        line-height: 20px;
        text-align: center;
        min-height: 65px;
        display: flex;
        align-items: center;
        justify-content: center;
    `,
};
